import QRReader from './QRReader';

export default QRReader;
